
import Vue from 'vue';
import {
	TOKEN_COOLDOWN_TIME_BUCKET,
	TokenCooldownTimeBucket,
} from '@run-diffusion/shared';

export default Vue.extend({
	name: 'TokenCooldownTimeBucketPicker',
	props: {
		value: {
			type: String as () => TokenCooldownTimeBucket | null | undefined,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		timeBucketItems (): Array<{ label: string; value: TokenCooldownTimeBucket }> {
			// Only expose a subset of buckets as selectable options:
			// 1min, 2min, 5min, 10min, 15min, 30min, 1hr, 2hr, 3hr, 12hr
			const selectableBuckets: TokenCooldownTimeBucket[] = [
				TOKEN_COOLDOWN_TIME_BUCKET['1min'],
				TOKEN_COOLDOWN_TIME_BUCKET['2min'],
				TOKEN_COOLDOWN_TIME_BUCKET['5min'],
				TOKEN_COOLDOWN_TIME_BUCKET['10min'],
				TOKEN_COOLDOWN_TIME_BUCKET['15min'],
				TOKEN_COOLDOWN_TIME_BUCKET['30min'],
				TOKEN_COOLDOWN_TIME_BUCKET['1hr'],
				TOKEN_COOLDOWN_TIME_BUCKET['2hr'],
				TOKEN_COOLDOWN_TIME_BUCKET['3hr'],
				TOKEN_COOLDOWN_TIME_BUCKET['12hr'],
			];

			return selectableBuckets.map((bucket) => {
				let label = '';
				switch (bucket) {
					case TOKEN_COOLDOWN_TIME_BUCKET['1min']:
						label = '1 minute';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['2min']:
						label = '2 minutes';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['5min']:
						label = '5 minutes';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['10min']:
						label = '10 minutes';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['15min']:
						label = '15 minutes';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['30min']:
						label = '30 minutes';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['1hr']:
						label = '1 hour';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['2hr']:
						label = '2 hours';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['3hr']:
						label = '3 hours';
						break;
					case TOKEN_COOLDOWN_TIME_BUCKET['12hr']:
						label = '12 hours';
						break;
					default:
						label = bucket;
				}
				return { label, value: bucket };
			});
		},
	},
});
